module.exports = __webpack_public_path__ + "static/0051-30177fb135695df668726b3618d7065b.png";